import { initLinksNumber } from '../main.js';
import { scrollToElementById } from '../main.js';

class Nav
{
    constructor()
    {
		this.match = gsap.matchMedia();
		this.menuToggle = document.querySelector(".menu-toggle");
		this.currentSubMenu = null;
		this.currentScroll = 0;		
		this.init();
    }

    init()
	{
		let targetElementId;
		if(window.location.hash) {
			targetElementId = window.location.hash.substring(1);
			scrollToElementById(targetElementId);
		}

		window.addEventListener("hashchange", (e) =>
		{
			targetElementId = window.location.hash.substring(1);
			scrollToElementById(targetElementId);
		});

		initLinksNumber("a[data-number]");
	
		let calendlyLinks = document.querySelectorAll(".calendly");
		calendlyLinks.forEach(calendly =>
		{
			calendly.addEventListener("click", (e) =>
			{
				e.preventDefault();
				let urlCalendly = e.currentTarget.href;
				Calendly.initPopupWidget({url:urlCalendly});
				return false;
			});
		});

		const urlParams = new URLSearchParams(window.location.search);
		const calendlyParam = urlParams.get('calendly');
		if(calendlyParam) {
			let urlCal = calendly[calendlyParam];
			console.log(urlCal);
			Calendly.initPopupWidget({url:urlCal});	
		}

		if(this.menuToggle) {
			this.menuToggle.addEventListener("mouseenter", (e) => this.onEnterMenu(e));
			this.menuToggle.addEventListener("mouseleave", (e) => this.onLeaveMenu(e));
			this.match.add("(max-width: 1024px)", () => {
				gsap.set("header", {height:"90px"});
				this.menuToggle.addEventListener("click", (e) => this.onToggleMenu(e));
				gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration: 0.1, y:-7, rotation:0, alpha:1});
				gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:nth-child(2)"), {duration:0.15, rotation:0, x:0, ease:"power3.out"});
				gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, y:7, x:0, ease:"power3.out"});
				
			});
		}

		this.match.add("(min-width: 1025px)", () => {
			gsap.set("header", {height:"114px"});
			this.closeMenu();
			this.menuToggle.classList.remove("over");
			document.querySelector("header").classList.remove("active");
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration: 0.1, y:-7, rotation:0, alpha:1});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:nth-child(2)"), {duration:0.15, rotation:0, x:0, ease:"power3.out"});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, y:7, x:0, ease:"power3.out"});
		});
		
		if(document.querySelector(".footer-search-form")) {
			document.querySelector(".footer-search-form h4").addEventListener("click", (e) =>
			{
				if(!document.querySelector(".footer-search-form").classList.contains("active")) {
					let py = document.querySelector(".footer-search-form").offsetHeight;
					gsap.to(".footer-search-form", {duration:0.5, y:-py, ease:"expo.out"});
					gsap.to(".footer-search-form .search-form-container", {duration:0.5, backgroundColor:"#5084A8", ease:"expo.out"});
					document.querySelector(".footer-search-form").classList.toggle("active");
				} else {
					gsap.to(".footer-search-form", {duration:0.5, y:-57, ease:"expo.out"});
					gsap.to(".footer-search-form .search-form-container", {duration:0.5, backgroundColor:"red", ease:"expo.out"});
					document.querySelector(".footer-search-form").classList.toggle("active");
				}
			});
			
			document.addEventListener("click", (e) =>
			{
				if(!document.querySelector(".footer-search-form").contains(e.target) && document.querySelector(".footer-search-form").classList.contains("active")) {
					gsap.to(".footer-search-form", {duration:0.5, y:-57, ease:"expo.out"});
					document.querySelector(".footer-search-form").classList.toggle("active");
				}
			});
		}

		let subMenus = document.querySelectorAll(".menu-item-has-children");
		subMenus.forEach(subMenu =>
		{
			subMenu.querySelector("& > a").addEventListener("click", (e) =>
			{
				e.preventDefault();
				return false;
			});

			subMenu.addEventListener("mouseenter", (e) =>
			{
				let subMenu = e.target.querySelector("ul");
				
				if(subMenu.querySelector(".menu-item-image")) {
					gsap.set(".menu-item-image", {alpha:0, overwrite:true});
				}

				gsap.set(subMenu, {display:"flex", height:"auto", alpha:0, y:-20});
				let h = subMenu.offsetHeight;
				gsap.set(subMenu, {height:0});
				
				if(window.innerWidth <= 1024 && this.currentSubMenu != null) {
					h = 0;
					gsap.set(subMenu, {height:0});
				}

				subMenu.classList.toggle("active");
				this.currentSubMenu = subMenu;

				gsap.to(subMenu, {duration:0.5, alpha:1, y:0, height:"auto", ease:"expo.out", overwrite:true, onComplete:() =>
				{
					if(subMenu.querySelector(".menu-item-image")) {
						gsap.to(".menu-item-image", {duration:0.8, alpha:1, ease:"power3.out"});
					}
				}});
			});

			subMenu.addEventListener("mouseleave", (e) =>
			{
				let subMenu = e.target.querySelector("ul");
				subMenu.classList.toggle("active");
				let h = "auto";
				if(window.innerWidth <= 1024) {
					h = 0;
				}
				gsap.to(subMenu, {duration:0.4, alpha:0, y:0, height:h, ease:"expo.out", onComplete:() => 
				{
					gsap.set(subMenu, {display:"none"});
					this.currentSubMenu = null;
				}});
			});
		});

		let subMenuItems = document.querySelectorAll(".sub-menu-projets a");
		subMenuItems.forEach(subMenuItem =>
		{
			subMenuItem.addEventListener("mouseenter", (e) =>
			{
				let image_container = subMenuItem.closest(".menu-item-has-children").querySelector(".menu-item-image");
				let image_url = e.target.dataset.projet_image;
				let imageExists = document.querySelector(`.menu-item-image img[src$="${image_url}"]`);
				if(!imageExists) {
					let image = new Image();
					image.src = image_url;
					image.onload = () =>
					{
						image.style.opacity = 0;
						image_container.appendChild(image);
						gsap.to(image, {duration:0.5, alpha:1, ease:"power3.out"});
					};
				} else {
					imageExists.style.opacity = 0;
					image_container.appendChild(imageExists);
					gsap.to(imageExists, {duration:0.5, alpha:1, ease:"power3.out"});
				}
			});

			// subMenuItem.addEventListener("mouseleave", (e) =>
			// {
			// });
		});

		//Le bouton PLAY des vidéos
		if(document.querySelector('.row-video .placeholder')) {
            document.querySelector('.row-video .placeholder').addEventListener("click", (e) =>
            {
                let placeholder = e.currentTarget;
                let videoFrame = placeholder.nextElementSibling;
                let videoSrc = videoFrame.dataset.src;
                videoFrame.src = videoSrc;
                //video.play();
                gsap.to(placeholder, {alpha:0, duration:0.4, ease:"power3.out", onComplete:() =>
                {
                    gsap.set(placeholder, {display:"none"});
                }});
            });
        }
	}

	onEnterMenu(e)
	{
		if(!document.querySelector("header").classList.contains("active")) {
			this.menuToggle.classList.toggle("over");
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration: 0.1, y:-11, alpha:0});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:nth-child(2)"), {duration:0.15, rotation:90, x:0.5, ease:"power3.out"});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, y:0, x:0.5, ease:"power3.out"});
		}
	}

	onLeaveMenu(e)
	{
		if(!document.querySelector("header").classList.contains("active")) {
			this.menuToggle.classList.toggle("over");
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration: 0.1, y:-7, rotation:0, alpha:1});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:nth-child(2)"), {duration:0.15, rotation:0, x:0, ease:"power3.out"});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, y:7, x:0, ease:"power3.out"});
		}
	}

	onToggleMenu(e)
	{
		if(!document.querySelector("header").classList.contains("moving")) {
			
			document.querySelector("header").classList.add("moving");

			if(!document.querySelector("header").classList.contains("active")) {

				this.currentScroll = window.scrollY;
				gsap.set('body', {"position":"fixed", "overflow-y":"scroll", "width":"100%"});

				if(!this.menuToggle.classList.contains("over")) {
					this.menuToggle.classList.toggle("over");
					gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration:0.15, rotation:90, x:0, y:0, ease:"power3.out"});
					gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, y:0, x:0, ease:"power3.out"});
				}

				gsap.to("header", {duration:0.9, height:"100%", ease:"power3.out", onComplete:() => document.querySelector("header").classList.remove("moving")});
				gsap.to(this.menuToggle, {duration:0.2, rotation:45, x:0, y:0, ease:"power3.out"});
				gsap.from(".menu > li", {duration:0.8, delay:0, alpha:0, y:20, ease:"expo.out", stagger:0.05});
				
			} else {
				this.closeMenu();
			}

			document.querySelector("header").classList.toggle("active");
		}
	}

	closeMenu()
	{
		this.match.add("(max-width: 1024px)", () => {
			gsap.set('body', {"position":"", "overflow-y":"", "width":""});
			window.scrollTo(0, this.currentScroll);

			document.querySelector("header").classList.add("moving");

			gsap.to(document.querySelector("header"), {duration:0.5, height:"90px", ease:"power3.out", onComplete:() =>
			{
				document.querySelector("header").classList.remove("moving");
			}});

			gsap.to(this.menuToggle, {duration:0.2, rotation:0, x:0, y:0, ease:"power3.out"});
		});
	}
}

export default Nav;